<a [routerLink]="[componentOptions.sref,componentOptions.srefParams]">
    {{value}}
</a>
<a [routerLink]="[componentOptions.sref,componentOptions.srefParams]"
    target="_blank">
    <i class="far fa-sm fa-external-link p-r-half"></i>
</a>